import React from "react"
import styles from "./sideFilter.module.css"
import { MdOutlineArrowForward, MdOutlineManageSearch } from "react-icons/md"
import Select from "../../../components/Form/Select"
import FormGroup from "../../../components/Form/FormGroup"
import Button from "../../../components/Form/Button"
import DatePicker from "../../../components/Form/DatePicker"
import FormGroupInline from "../../../components/Form/FormGroupInline"
import { useAuth } from "../../../contexts/authContext"
import { useData } from "../../../contexts/dataContext"
import BreakForm from "../../../components/Form/BreakForm"
import AdditionalFieldFilters from "../../../components/LeadFilters/AdditionalFieldFilters"
import CollectionFilter from "../../../components/LeadFilters/CollectionFilter"
import SavedFilters from "../../../components/LeadFilters/SavedFilters"
import UtmFilters from "../../../components/LeadFilters/UtmFilters"
import { getUsersByTeams } from "../../../utils/utils"
import { interactionStatusOptions } from "../../../utils/interactionFilters"

const SideFilter = ({ filters = {}, stages = [], handleChange = () => { }, onLoadFilters = () => { }, cleanFilters = () => { }, onSubmit = () => { }, onClose = () => { } }) => {
    const { funnels, teams, users, products, origins, campaigns, flagsByoptions, additionalFields, metaAdsAdsName, metaAdsAdsetsName, metaAdsCampaignsName, metaAdsFormsName, metaAdsPagesName } = useData()
    const { permissions } = useAuth()
    const availableUsers = filters.teams?.length ? getUsersByTeams(filters.teams, users, teams) : users || []

    const onChangePeriod = (dateStart, dateEnd, datePreset = null) => {
        handleChange("dateStart", dateStart)
        handleChange("dateEnd", dateEnd)
        handleChange("datePreset", datePreset)
    }

    return (
        <div className={styles.background} onClick={onClose}>
            <div className={styles.sideFilter} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <div className={styles.description}>
                        <MdOutlineManageSearch />
                        <div>
                            <strong>Filtrar dashboard</strong>
                            <span>Combine critérios para analisar os resultados</span>
                        </div>
                    </div>
                    <div className={styles.close} onClick={onClose}>
                        <MdOutlineArrowForward />
                    </div>
                </div>
                <div className={styles.body}>
                    <SavedFilters scope="dashboard-kanban" filters={filters} onLoad={onLoadFilters} />
                    <BreakForm title="Filtros principais" showAction={false} borderColor="var(--border-subtle-color)" />
                    <FormGroup labelText="Funil">
                        <Select name="Funil" placeholder="Pesquise um funil" options={funnels || []} selected={filters.funnels || []} onChange={(value) => handleChange("funnels", value)} multiple={true} />
                    </FormGroup>
                    <FormGroup labelText="Etapa">
                        <Select name="Etapa" placeholder="Pesquise uma etapa" options={stages || []} selected={filters.stages || []} onChange={(value) => handleChange("stages", value)} multiple={true} />
                    </FormGroup>
                    <FormGroup labelText="Período">
                        <DatePicker name="Período" dateStart={filters.dateStart || ""} dateEnd={filters.dateEnd || ""} onChange={(dateStart, dateEnd, _timeStart, _timeEnd, metadata) => onChangePeriod(dateStart, dateEnd, metadata?.preset)} multiple={true} />
                    </FormGroup>
                    <BreakForm title="Relacionamentos" showAction={false} borderColor="var(--border-subtle-color)" />
                    <CollectionFilter label="Produto" name="Produtos" placeholder="Pesquise um produto" options={products || []} selected={filters.products || []} operator={filters.productsOperator || "any"} onValuesChange={value => handleChange("products", value)} onOperatorChange={value => handleChange("productsOperator", value)} />
                    <FormGroup labelText="Origem">
                        <Select name="Origens" placeholder="Pesquise uma origem" options={origins || []} selected={filters.origins || []} onChange={(value) => handleChange("origins", value)} multiple={true} />
                    </FormGroup>
                    <FormGroup labelText="Campanha">
                        <Select name="Campanhas" placeholder="Pesquise uma campanha" options={campaigns || []} selected={filters.campaigns || []} onChange={(value) => handleChange("campaigns", value)} multiple={true} />
                    </FormGroup>
                    <CollectionFilter label="Etiqueta" name="Etiquetas" placeholder="Pesquise uma etiqueta" options={flagsByoptions || []} selected={filters.flags || []} operator={filters.flagsOperator || "any"} onValuesChange={value => handleChange("flags", value)} onOperatorChange={value => handleChange("flagsOperator", value)} />
                    <FormGroup labelText="Interação">
                        <Select name="Interação" placeholder="Todos" options={interactionStatusOptions} selected={filters.interactionStatus || ""} onChange={(value) => handleChange("interactionStatus", value)} multiple={false} />
                    </FormGroup>
                    <FormGroup labelText="Equipe">
                        <Select name="Equipes" placeholder="Pesquise uma equipe" options={teams || []} selected={filters.teams || []} onChange={(value) => handleChange("teams", value)} multiple={true} />
                    </FormGroup>
                    {permissions?.crm > 1 &&
                        <CollectionFilter label="Responsável" name="Responsáveis" placeholder="Pesquise um responsável" options={availableUsers} selected={filters.users || []} operator={filters.usersOperator || "any"} onValuesChange={value => handleChange("users", value)} onOperatorChange={value => handleChange("usersOperator", value)} />
                    }
                    <BreakForm title="Aquisição / UTM" showAction={false} borderColor="var(--background-form)" />
                    <UtmFilters value={filters.utmFilters || []} onChange={value => handleChange("utmFilters", value)} />
                    {additionalFields?.some(field => field.is_visible !== false) &&
                        <>
                            <BreakForm title="Campos adicionais" showAction={false} borderColor="var(--background-form)" />
                            <AdditionalFieldFilters fields={additionalFields} value={filters.additionalFieldFilters || []} onChange={value => handleChange("additionalFieldFilters", value)} />
                        </>
                    }
                    {/* Meta Ads */}
                    {(metaAdsAdsName?.length > 0 || metaAdsAdsetsName?.length > 0 || metaAdsCampaignsName?.length > 0 || metaAdsFormsName?.length > 0 || metaAdsPagesName?.length > 0) &&
                        <BreakForm title="Meta Ads" showAction={false} borderColor="var(--background-form)" />
                    }
                    {metaAdsAdsName?.length > 0 &&
                        <FormGroup labelText="Ad Name">
                            <Select name="Ad Name" placeholder="Pesquise uma opção" options={metaAdsAdsName || []} selected={filters.metaAdsAdsName || []} onChange={(value) => handleChange("metaAdsAdsName", value)} multiple={true} />
                        </FormGroup>
                    }
                    {metaAdsAdsetsName?.length > 0 &&
                        <FormGroup labelText="Adset Name">
                            <Select name="Adset Name" placeholder="Pesquise uma opção" options={metaAdsAdsetsName || []} selected={filters.metaAdsAdsetsName || []} onChange={(value) => handleChange("metaAdsAdsetsName", value)} multiple={true} />
                        </FormGroup>
                    }
                    {metaAdsCampaignsName?.length > 0 &&
                        <FormGroup labelText="Campaign Name">
                            <Select name="Campaign Name" placeholder="Pesquise uma opção" options={metaAdsCampaignsName || []} selected={filters.metaAdsCampaignsName || []} onChange={(value) => handleChange("metaAdsCampaignsName", value)} multiple={true} />
                        </FormGroup>
                    }
                    {metaAdsFormsName?.length > 0 &&
                        <FormGroup labelText="Form Name">
                            <Select name="Form Name" placeholder="Pesquise uma opção" options={metaAdsFormsName || []} selected={filters.metaAdsFormsName || []} onChange={(value) => handleChange("metaAdsFormsName", value)} multiple={true} />
                        </FormGroup>
                    }
                    {metaAdsPagesName?.length > 0 &&
                        <FormGroup labelText="Page Name">
                            <Select name="Page Name" placeholder="Pesquise uma opção" options={metaAdsPagesName || []} selected={filters.metaAdsPagesName || []} onChange={(value) => handleChange("metaAdsPagesName", value)} multiple={true} />
                        </FormGroup>
                    }
                    {/* End Meta Ads */}
                </div>
                <div className={styles.footer}>
                    <FormGroupInline>
                        <Button variant="secondary" onClick={cleanFilters}>Limpar</Button>
                        <Button variant="primary" onClick={onSubmit}>Aplicar filtros</Button>
                    </FormGroupInline>
                </div>
            </div>
        </div>
    )
}

export default SideFilter
